import { render } from "./MyCompalAD.vue?vue&type=template&id=53e100ca"
import script from "./MyCompalAD.vue?vue&type=script&lang=js"
export * from "./MyCompalAD.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__